import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { BRAND } from "../css/brand";
import Card from "../Components/Card";
import SimpleTable from "../Components/SimpleTable";
import KpiCard from "../Components/KpiCard";
import DistrictActivationsCard from "../Components/DistrictActivationsCard";
import StateActivationsCard from "../Components/StateActivationsCard";
import DatewiseActivationsChart from "../Components/DatewiseActivationsChart";
import MonthwiseCustomersChart from "../Components/MonthwiseCustomersChart";

export default function Dashboards() {
  const [role, setRole] = useState(null);
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  

  useEffect(() => {
    const stored = sessionStorage.getItem("authUserData1");
    if (stored) {
      try {
        const user = JSON.parse(stored);
        if (user?.data?.[0]) {
          setRole(Number(user.data[0].role));
          setUserId(user.data[0].id);
        }
      } catch (err) {
        console.error("Invalid session data:", err);
      }
    }
  }, []);

  const handleCardClick = (label) => {
    switch (label) {
      case "Keys (Avail)":
        navigate("/dashboard/inventory");
        break;
      case "CNFs":
        navigate("/dashboard/entities?tab=CNF");
        break;
      case "Super Stockists":
        navigate("/dashboard/entities?tab=Super%20Stockist");
        break;
      case "Distributors":
        navigate("/dashboard/entities?tab=Distributor");
        break;
      case "Micro Dist.":
        navigate("/dashboard/entities?tab=Micro%20Distributor");
        break;
      case "Retailers":
        navigate("/dashboard/entities?tab=Retailer");
        break;
      default:
        break;
    }
  };

  // ✅ Define card sets for each role
  const cardSets = {
    2: ["Keys (Avail)", "CNFs", "Super Stockists", "Distributors", "Micro Dist.", "Retailers", "Customers", "Today's Recommended", "Today's Chalte Chalte"],
    3: ["Keys (Avail)", "Super Stockists", "Distributors", "Micro Dist.", "Retailers", "Customers", "Today's Recommended", "Today's Chalte Chalte"],
    4: ["Keys (Avail)", "Distributors", "Micro Dist.", "Retailers", "Customers", "Today's Recommended", "Today's Chalte Chalte"],
    5: ["Keys (Avail)", "Micro Dist.", "Retailers", "Customers", "Today's Recommended", "Today's Chalte Chalte"],
    6: ["Keys (Avail)", "Retailers", "Customers", "Today's Recommended", "Today's Chalte Chalte"],
    7: ["Keys (Avail)", "Customers", "Today's Recommended", "Today's Chalte Chalte"],
  };

  const kpiLabels = cardSets[role] || [];

  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  const dayRetailerReg = days.map((d) => ({
    d,
    retailers: Math.floor(1 + Math.random() * 10),
    distributors: Math.floor(Math.random() * 3),
  }));

  const monthRetailerReg = months.map((m) => ({
    m,
    retailers: Math.floor(20 + Math.random() * 120),
    distributors: Math.floor(10 + Math.random() * 40),
  }));

  const geoActivation = [
    { name: "Pune", state: "Maharashtra", activations: 320 },
    { name: "Nashik", state: "Maharashtra", activations: 140 },
    { name: "Indore", state: "Madhya Pradesh", activations: 90 },
    { name: "Bhopal", state: "Madhya Pradesh", activations: 110 },
  ];

  const stateAgg = Object.values(
    geoActivation.reduce((acc, g) => {
      acc[g.state] = acc[g.state] || { state: g.state, activations: 0 };
      acc[g.state].activations += g.activations;
      return acc;
    }, {})
  );

  return (
    <div>
      <div className="flex justify-end mb-3">
        {role === 2 && (
        <div className="flex justify-end max-w-[270px] px-3 py-1 rounded-full border border-blue-200 bg-blue-50 text-sm text-blue-700 font-medium shadow-sm">
          <span className="">Helpline:&nbsp;</span>
          <span className="px-2 font-bold text-blue-700">7506017380</span><span>(12pm-7pm)</span>
        </div>
      )}
      </div>
      {/* KPI Section */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {kpiLabels.map((label) => (
          <KpiCard
            key={label}
            mode="dashboard"
            title={label}
            userId={userId}
            role={role}
            onClick={(lbl) => handleCardClick(lbl)}
          />
        ))}
      </div>

      {/* Charts */}
      <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
        <DatewiseActivationsChart/>
        <MonthwiseCustomersChart/>
      </section>

      {/* Tables */}
      {role === 2 && (
        <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
          <DistrictActivationsCard/>

          <StateActivationsCard/>
        </section>
        )}

    </div>
  );
}


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
// } from "recharts";
// import { BRAND } from "../css/brand";
// import Card from "../Components/Card";
// import SimpleTable from "../Components/SimpleTable";
// import KpiCard from "../Components/KpiCard";

// export default function Dashboards() {
//   const [role, setRole] = useState(null);
//   const [userId, setUserId] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         if (user?.data?.[0]) {
//           setRole(user.data[0].role);
//           setUserId(user.data[0].id);
//         }
//       } catch (err) {
//         console.error("Invalid session data:", err);
//       }
//     }
//   }, []);

//   const handleCardClick = (label) => {
//     switch (label) {
//        case "Keys (Avail)":
//         navigate("/dashboard/inventory");
//         break;
//       case "CNFs":
//         navigate("/dashboard/entities?tab=CNF");
//         break;
//       case "Super Stockists":
//         navigate("/dashboard/entities?tab=Super%20Stockist");
//         break;
//       case "Distributors":
//         navigate("/dashboard/entities?tab=Distributor");
//         break;
//       case "Micro Dist.":
//         navigate("/dashboard/entities?tab=Micro%20Distributor");
//         break;
//       case "Retailers":
//         navigate("/dashboard/entities?tab=Retailer");
//         break;
//       default:
//         break;
//     }
//   };

//   const days = Array.from({ length: 31 }, (_, i) => i + 1);
//   const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

//   const dayRetailerReg = days.map((d) => ({
//     d,
//     retailers: Math.floor(1 + Math.random() * 10),
//     distributors: Math.floor(Math.random() * 3),
//   }));

//   const monthRetailerReg = months.map((m) => ({
//     m,
//     retailers: Math.floor(20 + Math.random() * 120),
//     distributors: Math.floor(10 + Math.random() * 40),
//   }));

//   const geoActivation = [
//     { name: "Pune", state: "Maharashtra", activations: 320 },
//     { name: "Nashik", state: "Maharashtra", activations: 140 },
//     { name: "Indore", state: "Madhya Pradesh", activations: 90 },
//     { name: "Bhopal", state: "Madhya Pradesh", activations: 110 },
//   ];

//   const stateAgg = Object.values(
//     geoActivation.reduce((acc, g) => {
//       acc[g.state] = acc[g.state] || { state: g.state, activations: 0 };
//       acc[g.state].activations += g.activations;
//       return acc;
//     }, {})
//   );

//   return (
//     <div>
//       {/* KPI Cards */}
//       <KpiCard mode="dashboard" title="Key(Avails)" userId={userId} role={role} onClick={() => handleCardClick("Keys (Avail)")} />
//       <KpiCard mode="dashboard" title="Retailers" userId={userId} role={role} onClick={() => handleCardClick("Retailers")} />

//       {/* Charts */}
//       <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="Day-wise Registrations (Retailer & Distributor)">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={dayRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="d" tickFormatter={(v) => `Day ${v}`} />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line type="monotone" dataKey="retailers" name="Retailers" stroke={BRAND.blue} strokeWidth={2} />
//                 <Line type="monotone" dataKey="distributors" name="Distributors" stroke={BRAND.darkBlue} strokeWidth={2} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>

//         <Card brand={BRAND} title="Month-wise Registrations">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={monthRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="m" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="retailers" name="Retailers" fill={BRAND.blue} />
//                 <Bar dataKey="distributors" name="Distributors" fill={BRAND.darkBlue} />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>
//       </section>

//       {/* Tables */}
//       <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="District-wise Activations (Current Period)">
//           <SimpleTable
//             headers={["District", "State", "Activations"]}
//             rows={geoActivation.map((g) => [g.name, g.state, g.activations])}
//           />
//         </Card>

//         <Card brand={BRAND} title="State-wise Activations">
//           <SimpleTable
//             headers={["State", "Activations"]}
//             rows={stateAgg.map((s) => [s.state, s.activations])}
//           />
//         </Card>
//       </section>
//     </div>
//   );
// }


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import {
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
// } from "recharts";
// import { BRAND } from "../css/brand";
// import Card from "../Components/Card";
// import SimpleTable from "../Components/SimpleTable";

// export default function Dashboards() {
//   const [kpis, setKpis] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [role, setRole] = useState(null);
//   const [userId, setUserId] = useState(null);
//   const navigate = useNavigate();

//   const defaultKpis = [
//   { label: "Keys (Avail)", value: 0 },
//   { label: "CNFs", value: 0 },
//   { label: "Super Stockists", value: 0 },
//   { label: "Distributors", value: 0 },
//   { label: "Micro Dist.", value: 0 },
//   { label: "Retailers", value: 0 },
//   { label: "Customers", value: 0 },
//   { label: "Recommanded", value: 0 },
//   { label: "Chalte Chalte", value: 0 },
//   // { label: "Payments Pending", value: "₹ 0" },
//   // { label: "Tickets Open", value: 0 },
// ];

//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         if (user?.data?.[0]) {
//           setRole(user.data[0].role);
//           setUserId(user.data[0].id);
//         }
//       } catch (err) {
//         console.error("Invalid session data:", err);
//       }
//     }
//   }, []);

//   useEffect(() => {
//     if (!role || !userId) return;

//     const fetchDashboardCounts = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.post("https://spillas.com/api/v1/dashboard/count", {
//           id: userId,
//           role: role,
//         });

//         if (response) {
//           const data = response.data.data || response.data;
//           const dynamicKpis = [];

//           if (data.key_balances)
//             dynamicKpis.push({ label: "Keys (Avail)", value: data.key_balances.total_qty || 0 });
//           if (data.totals.total_cnf)
//             dynamicKpis.push({ label: "CNFs", value: data.totals.total_cnf.total || 0 });
//           if (data.totals.total_ss)
//             dynamicKpis.push({ label: "Super Stockists", value: data.totals.total_ss.total || 0 });
//           if (data.totals.total_dist)
//             dynamicKpis.push({ label: "Distributors", value: data.totals.total_dist.total || 0 });
//           if (data.totals.total_fos)
//             dynamicKpis.push({ label: "Micro Dist.", value: data.totals.total_fos.total || 0 });
//           if (data.totals.total_retailer)
//             dynamicKpis.push({ label: "Retailers", value: data.totals.total_retailer.total || 0 });
//           if (data.customers.total)
//             dynamicKpis.push({ label: "Customers", value: data.customers.total || 0 });
//           if (data.customers.smart)
//             dynamicKpis.push({ label: "Recommanded", value: data.customers.smart.today || 0 });
//           if (data.customers.chalte_chalte)
//             dynamicKpis.push({ label: "Chalte Chalte", value: data.customers.chalte_chalte.today || 0 });
//           if (data.payments_pending)
//             dynamicKpis.push({ label: "Payments Pending", value: `₹ ${data.payments_pending}` });
//           if (data.tickets_open)
//             dynamicKpis.push({ label: "Tickets Open", value: data.tickets_open });

//           setKpis(dynamicKpis);
//         } else {
//           console.error("API returned invalid status", response.data);
//           setKpis([]);
//         }
//       } catch (err) {
//         console.error("Error fetching dashboard data:", err);
//         setKpis([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboardCounts();
//   }, [role, userId]);

//   // ✅ Navigation logic for each KPI card
//   const handleCardClick = (label) => {
//     switch (label) {
//       case "Keys (Avail)":
//         navigate("/dashboard/inventory");
//         break;
//       case "CNFs":
//         navigate("/dashboard/entities?tab=CNF");
//         break;
//       case "Super Stockists":
//         navigate("/dashboard/entities?tab=Super%20Stockist");
//         break;
//       case "Distributors":
//         navigate("/dashboard/entities?tab=Distributor");
//         break;
//       case "Micro Dist.":
//         navigate("/dashboard/entities?tab=Micro%20Distributor");
//         break;
//       case "Retailers":
//         navigate("/dashboard/entities?tab=Retailer");
//         break;
//       default:
//         break;
//     }
//   };


//   // ---- Static data for charts & tables ----
//   const days = Array.from({ length: 31 }, (_, i) => i + 1);
//   const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
//   const dayRetailerReg = days.map((d) => ({
//     d,
//     retailers: Math.floor(1 + Math.random() * 10),
//     distributors: Math.floor(Math.random() * 3),
//     smart: Math.floor(Math.random() * 8),
//     regular: Math.floor(Math.random() * 12),
//   }));
//   const monthRetailerReg = months.map((m) => ({
//     m,
//     retailers: Math.floor(20 + Math.random() * 120),
//     distributors: Math.floor(10 + Math.random() * 40),
//     smart: Math.floor(40 + Math.random() * 100),
//     regular: Math.floor(60 + Math.random() * 140),
//   }));

//   const geoActivation = [
//     { name: "Pune", state: "Maharashtra", activations: 320 },
//     { name: "Nashik", state: "Maharashtra", activations: 140 },
//     { name: "Indore", state: "Madhya Pradesh", activations: 90 },
//     { name: "Bhopal", state: "Madhya Pradesh", activations: 110 },
//   ];
//   const stateAgg = Object.values(
//     geoActivation.reduce((acc, g) => {
//       acc[g.state] = acc[g.state] || { state: g.state, activations: 0 };
//       acc[g.state].activations += g.activations;
//       return acc;
//     }, {})
//   );

//   return (
//     <div>
//       {/* KPI CARDS */}
//      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
//         {(kpis && kpis.length > 0 ? kpis : defaultKpis).map((k, idx) => (
//           <motion.div
//             key={k.label}
//             initial={{ opacity: 0, y: 12 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.04 * idx }}
//             onClick={() => handleCardClick(k.label)}
//             className="cursor-pointer rounded-2xl border bg-white p-3 shadow-sm hover:shadow-md transition-all"
//           >
//             {/* KPI Label */}
//             <p className="text-[10px] sm:text-xs uppercase tracking-wide text-slate-500">
//               {k.label}
//             </p>

//             {/* KPI Value / Loader */}
//             <div className="mt-1 h-8 flex items-center">
//               {loading ? (
//                 <div className="h-6 w-16 bg-slate-200 animate-pulse rounded-md"></div>
//               ) : (
//                 <p
//                   className="text-xl sm:text-2xl font-semibold"
//                   style={{ color: BRAND.darkBlue }}
//                 >
//                   {k.value ?? 0}
//                 </p>
//               )}
//             </div>
//           </motion.div>
//         ))}
//       </div>



//       {/* CHARTS */}
//       <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="Day-wise Registrations (Retailer & Distributor)">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={dayRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="d" tickFormatter={(v) => `Day ${v}`} />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line type="monotone" dataKey="retailers" name="Retailers" stroke={BRAND.blue} strokeWidth={2} />
//                 <Line type="monotone" dataKey="distributors" name="Distributors" stroke={BRAND.darkBlue} strokeWidth={2} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>

//         <Card brand={BRAND} title="Month-wise Registrations">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={monthRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="m" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="retailers" name="Retailers" fill={BRAND.blue} />
//                 <Bar dataKey="distributors" name="Distributors" fill={BRAND.darkBlue} />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>
//       </section>

//       {/* SMART VS REGULAR */}
//       {/* <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="Day-wise Customer Activation (Smart vs Regular)">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={dayRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="d" tickFormatter={(v) => `Day ${v}`} />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line type="monotone" dataKey="smart" name="Smart" stroke={BRAND.blue} strokeWidth={2} />
//                 <Line type="monotone" dataKey="regular" name="Regular" stroke={BRAND.red} strokeWidth={2} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>

//         <Card brand={BRAND} title="Month-wise Activation (Smart vs Regular)">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={monthRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="m" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="smart" name="Smart" fill={BRAND.blue} />
//                 <Bar dataKey="regular" name="Regular" fill={BRAND.red} />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>
//       </section> */}

//       {/* TABLES */}
//       <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="District-wise Activations (Current Period)">
//           <SimpleTable
//             headers={["District", "State", "Activations"]}
//             rows={geoActivation.map((g) => [g.name, g.state, g.activations])}
//           />
//         </Card>

//         <Card brand={BRAND} title="State-wise Activations">
//           <SimpleTable
//             headers={["State", "Activations"]}
//             rows={stateAgg.map((s) => [s.state, s.activations])}
//           />
//         </Card>
//       </section>
//     </div>
//   );
// }


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { motion } from "framer-motion";
// import {
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
// } from "recharts";
// import { BRAND } from "../css/brand";
// import Card from "../Components/Card";
// import SimpleTable from "../Components/SimpleTable";

// export default function Dashboards() {
//   const [kpis, setKpis] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [role, setRole] = useState(null);
//   const [userId, setUserId] = useState(null);

//   useEffect(() => {
//      const stored = sessionStorage.getItem("authUserData1");
//      if (stored) {
//        try {
//          const user = JSON.parse(stored);
//          if (user?.data?.[0]) {
//            setRole(user.data[0].role);
//            setUserId(user.data[0].id);
//          }
//        } catch (err) {
//          console.error("Invalid session data:", err);
//        }
//      }
//    }, []);

//   useEffect(() => {
//     if (!role || !userId) return;

//     const fetchDashboardCounts = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.post("https://spillas.com/api/v1/dashboard/count", {
//           id: userId,
//           role: role,
//         });

//         if (response) {
//           const data = response.data.data || response.data; // adjust depending on API structure

//           // Transform API data into kpi cards (update mapping as per actual API keys)
//           const dynamicKpis = [];

//           if (data.key_balances)
//             dynamicKpis.push({ label: "Keys (Avail)", value: data.key_balances.total_qty || 0 });
//           if (data.totals.total_cnf)
//             dynamicKpis.push({ label: "CNFs", value: data.totals.total_cnf.active || 0 });
//           if (data.totals.total_ss)
//             dynamicKpis.push({ label: "Super Stockists", value: data.totals.total_ss.active || 0 });
//           if (data.totals.total_dist)
//             dynamicKpis.push({ label: "Distributors", value: data.totals.total_dist.active || 0 });
//           if (data.totals.total_fos)
//             dynamicKpis.push({ label: "Micro Dist.", value: data.totals.total_fos.active || 0 });
//           if (data.totals.total_retailer)
//             dynamicKpis.push({ label: "Retailers", value: data.totals.total_retailer.active || 0 });
//           if (data.customers.total)
//             dynamicKpis.push({ label: "Customers", value: data.customers.total || 0 });
//           if (data.customers.smart)
//             dynamicKpis.push({ label: "Recommanded", value: data.customers.smart.today || 0 });
//           if (data.customers.chalte_chalte)
//             dynamicKpis.push({ label: "Chalte Chalte", value: data.customers.chalte_chalte.today || 0 });
//           if (data.payments_pending)
//             dynamicKpis.push({ label: "Payments Pending", value: `₹ ${data.payments_pending}` });
//           if (data.tickets_open)
//             dynamicKpis.push({ label: "Tickets Open", value: data.tickets_open });

//           setKpis(dynamicKpis);
//         } else {
//           console.error("API returned invalid status", response.data);
//           setKpis([]);
//         }
//       } catch (err) {
//         console.error("Error fetching dashboard data:", err);
//         setKpis([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboardCounts();
//   }, [role, userId]);

//   // ---- Static data for charts & tables (unchanged) ----
//   const days = Array.from({ length: 31 }, (_, i) => i + 1);
//   const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
//   const dayRetailerReg = days.map((d) => ({
//     d,
//     retailers: Math.floor(1 + Math.random() * 10),
//     distributors: Math.floor(Math.random() * 3),
//     smart: Math.floor(Math.random() * 8),
//     regular: Math.floor(Math.random() * 12),
//   }));
//   const monthRetailerReg = months.map((m) => ({
//     m,
//     retailers: Math.floor(20 + Math.random() * 120),
//     distributors: Math.floor(10 + Math.random() * 40),
//     smart: Math.floor(40 + Math.random() * 100),
//     regular: Math.floor(60 + Math.random() * 140),
//   }));

//   const geoActivation = [
//     { name: "Pune", state: "Maharashtra", activations: 320 },
//     { name: "Nashik", state: "Maharashtra", activations: 140 },
//     { name: "Indore", state: "Madhya Pradesh", activations: 90 },
//     { name: "Bhopal", state: "Madhya Pradesh", activations: 110 },
//   ];
//   const stateAgg = Object.values(
//     geoActivation.reduce((acc, g) => {
//       acc[g.state] = acc[g.state] || { state: g.state, activations: 0 };
//       acc[g.state].activations += g.activations;
//       return acc;
//     }, {})
//   );

//   return (
//     <div>
//       {/* KPI CARDS */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
//         {kpis.length > 0 ? (
//           kpis.map((k, idx) => (
//             <motion.div
//               key={k.label}
//               initial={{ opacity: 0, y: 12 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.04 * idx }}
//               className="rounded-2xl border bg-white p-3 shadow-sm"
//             >
//               <p className="text-[10px] sm:text-xs uppercase tracking-wide text-slate-500">
//                 {k.label}
//               </p>

//               {/* VALUE OR LOADER */}
//               {loading ? (
//                 <div className="mt-1 h-6 w-16 bg-slate-200 animate-pulse rounded-md"></div>
//               ) : (
//                 <p
//                   className="mt-1 text-xl sm:text-2xl font-semibold"
//                   style={{ color: BRAND.darkBlue }}
//                 >
//                   {k.value}
//                 </p>
//               )}
//             </motion.div>
//           ))
//         ) : (
//           <p className="col-span-full text-center text-sm text-red-500 py-4">
//             No data available for this role.
//           </p>
//         )}
//       </div>

//       {/* CHARTS */}
//       <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="Day-wise Registrations (Retailer & Distributor)">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={dayRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="d" tickFormatter={(v) => `Day ${v}`} />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line type="monotone" dataKey="retailers" name="Retailers" stroke={BRAND.blue} strokeWidth={2} />
//                 <Line type="monotone" dataKey="distributors" name="Distributors" stroke={BRAND.darkBlue} strokeWidth={2} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>

//         <Card brand={BRAND} title="Month-wise Registrations">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={monthRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="m" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="retailers" name="Retailers" fill={BRAND.blue} />
//                 <Bar dataKey="distributors" name="Distributors" fill={BRAND.darkBlue} />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>
//       </section>

//       {/* SMART VS REGULAR */}
//       <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="Day-wise Customer Activation (Smart vs Regular)">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={dayRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="d" tickFormatter={(v) => `Day ${v}`} />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line type="monotone" dataKey="smart" name="Smart" stroke={BRAND.blue} strokeWidth={2} />
//                 <Line type="monotone" dataKey="regular" name="Regular" stroke={BRAND.red} strokeWidth={2} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>

//         <Card brand={BRAND} title="Month-wise Activation (Smart vs Regular)">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={monthRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="m" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="smart" name="Smart" fill={BRAND.blue} />
//                 <Bar dataKey="regular" name="Regular" fill={BRAND.red} />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>
//       </section>

//       {/* TABLES */}
//       <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="District-wise Activations (Current Period)">
//           <SimpleTable
//             headers={["District", "State", "Activations"]}
//             rows={geoActivation.map((g) => [g.name, g.state, g.activations])}
//           />
//         </Card>

//         <Card brand={BRAND} title="State-wise Activations">
//           <SimpleTable
//             headers={["State", "Activations"]}
//             rows={stateAgg.map((s) => [s.state, s.activations])}
//           />
//         </Card>
//       </section>
//     </div>
//   );
// }


// import React from "react";
// import { motion } from "framer-motion";
// import { ResponsiveContainer, LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
// import { BRAND } from "../css/brand";
// import Card from "../Components/Card";
// import SimpleTable from "../Components/SimpleTable";

// export default function Dashboards({ role }) {
//   const kpis = role === 2 ? [
//     { label: "CNFs", value: 4 },
//     { label: "Super Stockists", value: 12 },
//     { label: "Distributors", value: 54 },
//     { label: "Micro Dist.", value: 87 },
//     { label: "Retailers", value: 1240 },
//     { label: "Keys (Avail)", value: 4120 },
//     { label: "Payments Pending", value: "₹ 46.2 L" },
//     { label: "Tickets Open", value: 18 },
//   ] : role === 3 ? [
//     { label: "Super Stockists", value: 3 },
//     { label: "Distributors", value: 11 },
//     { label: "Retailers", value: 230 },
//     { label: "Payments Pending", value: "₹ 8.1 L" },
//   ] : role === 4 ? [
//     { label: "Distributors", value: 9 },
//     { label: "Retailers", value: 162 },
//     { label: "Payments Pending", value: "₹ 4.6 L" },
//   ] : role === 5 ? [
//     { label: "Micro Dist.", value: 3 },
//     { label: "Retailers", value: 28 },
//     { label: "Payments Pending", value: "₹ 62k" },
//   ] : [
//     { label: "Retailers", value: 9 },
//     { label: "Payments Pending", value: "₹ 18k" },
//   ];

//   const days = Array.from({ length: 31 }, (_, i) => i + 1);
//   const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
//   const dayRetailerReg = days.map((d) => ({ d, retailers: Math.floor(1 + Math.random() * 10), distributors: Math.floor(Math.random() * 3), smart: Math.floor(Math.random()*8), regular: Math.floor(Math.random()*12) }));
//   const monthRetailerReg = months.map((m) => ({ m, retailers: Math.floor(20 + Math.random() * 120), distributors: Math.floor(10 + Math.random() * 40), smart: Math.floor(40 + Math.random()*100), regular: Math.floor(60 + Math.random()*140) }));

//   const geoActivation = [
//     { name: "Pune", state: "Maharashtra", activations: 320 },
//     { name: "Nashik", state: "Maharashtra", activations: 140 },
//     { name: "Indore", state: "Madhya Pradesh", activations: 90 },
//     { name: "Bhopal", state: "Madhya Pradesh", activations: 110 },
//   ];
//   const stateAgg = Object.values(geoActivation.reduce((acc, g) => { acc[g.state] = acc[g.state] || { state: g.state, activations: 0 }; acc[g.state].activations += g.activations; return acc; }, {}));

//   return (
//     <div>
//       <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
//         {kpis.map((k, idx) => (
//           <motion.div key={k.label} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.04 * idx }} className="rounded-2xl border bg-white p-3 shadow-sm">
//             <p className="text-[10px] sm:text-xs uppercase tracking-wide text-slate-500">{k.label}</p>
//             <p className="mt-1 text-xl sm:text-2xl font-semibold" style={{ color: BRAND.darkBlue }}>{k.value}</p>
//           </motion.div>
//         ))}
//       </div>

//       <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="Day‑wise Registrations (Retailer & Distributor)">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={dayRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="d" tickFormatter={(v)=>`Day ${v}`} />
//                 <YAxis /><Tooltip /><Legend />
//                 <Line type="monotone" dataKey="retailers" name="Retailers" stroke={BRAND.blue} strokeWidth={2} />
//                 <Line type="monotone" dataKey="distributors" name="Distributors" stroke={BRAND.darkBlue} strokeWidth={2} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>
//         <Card brand={BRAND} title="Month‑wise Registrations">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={monthRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="m" /><YAxis /><Tooltip /><Legend />
//                 <Bar dataKey="retailers" name="Retailers" fill={BRAND.blue} />
//                 <Bar dataKey="distributors" name="Distributors" fill={BRAND.darkBlue} />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>
//       </section>

//       <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="Day‑wise Customer Activation (Smart vs Regular)">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={dayRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="d" tickFormatter={(v)=>`Day ${v}`} />
//                 <YAxis /><Tooltip /><Legend />
//                 <Line type="monotone" dataKey="smart" name="Smart" stroke={BRAND.blue} strokeWidth={2} />
//                 <Line type="monotone" dataKey="regular" name="Regular" stroke={BRAND.red} strokeWidth={2} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>
//         <Card brand={BRAND} title="Month‑wise Activation (Smart vs Regular)">
//           <div className="h-56">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={monthRetailerReg}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="m" /><YAxis /><Tooltip /><Legend />
//                 <Bar dataKey="smart" name="Smart" fill={BRAND.blue} />
//                 <Bar dataKey="regular" name="Regular" fill={BRAND.red} />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>
//       </section>

//       <section className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
//         <Card brand={BRAND} title="District‑wise Activations (Current Period)">
//           <SimpleTable headers={["District", "State", "Activations"]} rows={geoActivation.map((g)=>[g.name, g.state, g.activations])} />
//         </Card>
//         <Card brand={BRAND} title="State‑wise Activations">
//           <SimpleTable headers={["State", "Activations"]} rows={stateAgg.map((s)=>[s.state, s.activations])} />
//         </Card>
//       </section>
//     </div>
//   );
// }